<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading {{ $t('pageHeader.deletedInvoice') }}
    v-card-title
      v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
    v-data-table(:headers='headers', :items='invoice', :search="search", :loading='loading', :pagination.sync='pagination')
        template(slot='items', slot-scope='props')
          td.text-xs-left {{ props.item.invoiceID }}
          td.text-xs-left {{ $moment(props.item.createDateTime).format('MM/DD/YYYY') }}
          td.text-xs-left {{ $moment(props.item.chargeDateTime).format('MM/DD/YYYY') }}
          td.text-xs-center {{ props.item.collectCounter }}
          td.text-xs-right {{ props.item.invoiceAmount | currency }}
          td.text-xs-left {{ props.item.deleteReason }}
        v-alert(slot='no-results', :value='true', color='error', icon='warning')
          | Your search for "{{ search }}" found no results.
    

</template>

<script>
import invoiceService from '../service.js'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      headers: [
        {
          text: this.$t('labels.invoiceNumber'),
          value: 'invoiceID',
          sortable: true,
          width: '10%',
        },
        {
          text: this.$t('labels.createdAt'),
          value: 'createDateTime',
          sortable: true,
          width: '10%',
        },
        {
          text: this.$t('labels.chargeDate'),
          value: 'chargeDateTime',
          width: '10%',
          sortable: true,
        },
        {
          text: this.$t('labels.collectCount'),
          value: 'collectCounter',
          width: '5%',
          sortable: true,
        },
        {
          text: this.$t('labels.invoiceAmount'),
          value: 'invoiceAmount',
          sortable: true,
        },
        {
          text: this.$t('labels.reason'),
          value: 'refundReason',
          sortable: true,
        },
      ],
      search: null,
      invoice: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'invoiceID',
        descending: true,
      },
    }
  },
  computed: {
    ...mapGetters('location', ['location'])
  },
  created() {
    this.getList()
  },
  watch: {
    location() {
      this.getList()
    }
  },
  methods: {
    getList() {
      this.loading = true
      return invoiceService
      .getByIdDeleted(this.location.storeID)
      .then((response) => {
        this.invoice = response.data
        this.loading = false
        return response
      })
    }
  }
}
</script>

<style scoped>
</style>